"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = _interopRequireDefault(require("./config"));
var _Api = _interopRequireDefault(require("./Api"));
var _AmqpBindingsResolver = _interopRequireDefault(require("./AmqpBindingsResolver"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const postal = (0, _Api.default)(_config.default);
const resolver = (0, _AmqpBindingsResolver.default)(postal);
postal.configuration.resolver = resolver;
var _default = postal;
exports.default = _default;